import { useSyncExternalStore } from 'react';
import { getLoadingRevision, hasPendingRequests, subscribeInformationLoading } from '../../utils/dataLoading';
import './display.css';
export function useSectionLoading(requests = []) {
    useSyncExternalStore(subscribeInformationLoading, getLoadingRevision, getLoadingRevision)
    return hasPendingRequests(requests)
}
export const sectionRequests = title => {
    const text = String(title || '').toLowerCase()
    if (/users/.test(text)) return ['fetchOrgAdminUsers']
    if (/payroll/.test(text)) return ['fetchPayrollRecords']
    if (/invoice|statement|outstanding amount/.test(text)) return ['fetchInvoices']
    if (/task|appointment/.test(text)) return ['fetchTasks']
    if (/worker status|availability|hours|available workers|working|on leave/.test(text)) return ['fetchWorkers', 'fetchWorkerLeaves', 'fetchTimeSheet', 'fetchAllocations']
    if (/allocation/.test(text)) return ['fetchAllocations', 'fetchCancelledAllocations', 'fetchIncompleteAllocations', 'fetchWorkers', 'fetchClients', 'fetchSites']
    if (/timesheet/.test(text)) return ['fetchTimeSheet', 'fetchSitePortal']
    if (/worker|audience/.test(text)) return ['fetchWorkers']
    if (/client|site/.test(text)) return ['fetchClients', 'fetchSites', 'fetchSitePortal']
    if (/asset|equipment/.test(text)) return ['fetchAssets']
    if (/announcement|draft/.test(text)) return ['fetchJobMarket']
    return []
}
export default function SectionSkeleton() {
    return <div className="uiSectionSkeleton" role="status" aria-label="Loading…"><span /><span /><span /></div>
}
